export default __webpack_public_path__ + "static/media/ticket25.44a43fc5.jpg";